import { useCallback, useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router'
import { Close, Search } from '@mui/icons-material'
import { Box, IconButton, InputAdornment, TextField, useTheme } from '@mui/material'

import useStyles from '../index.styles'

const SearchComponent = ({ searchText, setSearchText }: { searchText: string; setSearchText: React.Dispatch<React.SetStateAction<string>> }) => {
  const classes = useStyles
  const theme = useTheme()

  const { deviceId } = useParams()
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab') || 'alerts'

  // Clear search when the device id changes
  useEffect(() => {
    setSearchText('')
  }, [deviceId, setSearchText])

  // clear search if user changes tabs
  useEffect(() => {
    setSearchText('')
  }, [setSearchText, tab])

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setSearchText(event.target.value)
    },
    [setSearchText]
  )

  return (
    <Box sx={classes.searchContainer(theme)}>
      <TextField
        value={searchText}
        onChange={onChange}
        placeholder="Search"
        variant="outlined"
        size="small"
        sx={classes.searchTextField}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Search fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: searchText ? (
              <InputAdornment position="end">
                <IconButton onClick={() => setSearchText('')} aria-label="Clear Search">
                  <Close fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
            sx: classes.searchTextFieldInput,
          },
        }}
      />
    </Box>
  )
}

export default SearchComponent
